import React, { useState, useEffect } from 'react';
import { MdHouseSiding, MdOutlineWindow  } from "react-icons/md";
import { PiSolarRoof } from "react-icons/pi";
import { BsFillDoorOpenFill } from "react-icons/bs";
import { FaCalculator } from "react-icons/fa6";


const LeftSideBar = () => {
    const [activeElement, setActiveElement] = useState('wall'); 
    const [isVisible, setIsVisible] = useState(true);
    const [showCalculations, setShowCalculations] = useState(true); 
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const toggleCalculations = () => {
        if (windowWidth < 991) {
            setShowCalculations(prev => !prev);
        }
    };

    const buttons = [
        {
            icon: <MdHouseSiding size={35} />,
            title: "Add Wall",
            action: () => setActiveElement('wall')
        },
        {
            icon: <PiSolarRoof size={35} />,
            title: "Add Roof",
            action: () => setActiveElement('roof')
        },
        {
            icon: <MdOutlineWindow size={35} />,
            title: "Add Window",
            action: () => setActiveElement('window')
        },
        {
            icon: <BsFillDoorOpenFill size={35} />,
            title: "Add Door",
            action: () => setActiveElement('door')
        }
    ];

    const designs = [
        { name: 'Vinyl ', color: 'bg-stone-900' },
        { name: 'Wood ', color: 'bg-stone-700' },
        { name: 'Cement', color: 'bg-stone-500' },
        { name: 'Stone ', color: 'bg-stone-400' }
    ];

    const colours = [
        { name: 'White', color: 'bg-white' },
        { name: 'Brown', color: 'bg-orange-950' },
        { name: 'Gray', color: 'bg-slate-800' },
        { name: 'Black', color: 'bg-black' }
    ]

  return (
    <div className="w-full xs:border-b-2 xs:border-b-slate-800 xs:p-5 lg:border-b-0 lg:border-t-0 lg:w-1/3 lg:border-l-0 lg:border-r-2 lg:border-r-slate-800 p-16 pt-14 pb-5 sticky top-0 h-screen overflow-y-auto">
            <h1 className="text-5xl text-center font-semibold mb-4 lg:text-6xl">Edit House</h1>
            <div className="xs:gap-7 xs:flex xs:justify-center lg:gap-1 space-x-2 mb-4 lgl:gap-7 ">
                {buttons.map((button, index) => (
                    <button key={index} className={`btn btn-square btn-ghost rounded-xl bg-transparent border-2 border-textColor hover:bg-hoverColor hover:scale-110`} title={button.title} onClick={button.action}>
                        {button.icon}
                    </button>
                ))}
            </div>
            
            {/*Wall*/}
            {activeElement === 'wall' && 
            <div>
                <div className="flex max-w-[300px] mt-6 mb-4 ml-auto mr-auto p-3 justify-between bg-slate-600 rounded-xl text-textWhiteColor cursor-pointer hover:bg-hoverColor lg:hover:bg-slate-600" onClick={toggleCalculations}>
                    <p className="font-bold">Siding Calculations</p>
                    <FaCalculator size={25}/>
                </div>
                {showCalculations &&
                <>
                    <div className="flex font-bold text-base text-left p-5">
                        <p>
                            To edit or remove an existing gable on the house,
                            click on the siding you want to edit or remove,
                            and update the dimensions that appear below.
                        </p>
                    </div>
                    <div className="xs:px-0 sm:px-5">
                        <div className="grid grid-cols-2 gap-2">
                            <div className="mb-6 relative">
                                <label className="block font-medium text-textColor mb-2">Height</label>
                                <div className="relative">
                                    <input type="text" placeholder="Height" className="input input-bordered w-full border-black rounded-xl pr-8 "/>
                                </div>
                            </div>
                            <div className="mb-6 relative">
                                <label className="block font-medium text-textColor mb-2">Width</label>
                                <div className="relative">
                                    <input type="text" placeholder="Width" className="input input-bordered w-full border-black rounded-xl pr-8"/>
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-2 gap-2">
                        <div className="mb-6">
                            <label for="left-side" className="block font-medium text-textColor mb-2">Left Side</label>
                            <select className="select select-bordered w-full border-black rounded-xl">
                                <option disabled selected>Select an option</option>
                                <option value="inside">Inside</option>
                                <option value="outside">Outside</option>
                            </select>
                        </div>
                        <div className="mb-6">
                            <label className="block font-medium text-textColor mb-2">Left Side</label>
                            <select className="select select-bordered w-full border-black rounded-xl">
                                <option disabled selected>Select an option</option>
                                <option value="inside">Inside</option>
                                <option value="outside">Outside</option>
                            </select>
                            </div>
                        </div>
                        <div className="mb-6">
                        <label className="block font-medium text-textColor mb-2">Design</label>
                        <div className="xs:flex xs:gap-2 sm:flex flex-row justify-around gap-5 lg:flex lg:flex-wrap">
                            {designs.map((design, index) => (
                                <div key={index} className="flex flex-col items-center gap-2">
                                    <div className={`h-16 w-16 rounded-xl shadow-lg cursor-pointer ${design.color}`}>
                                    </div>
                                    <div className="badge badge-neutral text-textWhiteColor p-2 rounded-xl text-xs text-center">
                                        {design.name}
                                    </div>
                                </div>
                            ))}
                        </div>
                        </div>
                        <div className="mb-6">
                        <label className="block font-medium text-textColor mb-2">Colour</label>
                        <div className="xs:flex xs:gap-2 sm:flex flex-row justify-around gap-5 lg:flex lg:flex-wrap">
                            {colours.map((colour, index) => (
                                <div key={index} className="flex flex-col items-center gap-2">
                                    <div className={`h-16 w-16 rounded-xl shadow-lg cursor-pointer ${colour.color}`}>
                                    </div>
                                    <div className="badge badge-neutral text-textWhiteColor p-2 rounded-xl text-xs text-center">
                                        {colour.name}
                                    </div>
                                </div>
                            ))}
                        </div>
                        </div>
                    </div>
                    <div className="flex justify-center mb-6 lg:gap-5 mt-10">
                        <button className="btn btn-active btn-neutral border-none rounded-xl text-textWhiteColor hover:bg-hoverColor">Add Wall</button>
                    </div>
                </>
            }   
            </div>
            }

            {/*Roof*/}
            {activeElement === 'roof' && 
            <div>
                <div className="flex max-w-[300px] mt-6 mb-4 ml-auto mr-auto p-3 justify-between bg-slate-600 rounded-xl text-textWhiteColor cursor-pointer hover:bg-hoverColor" onClick={toggleCalculations}>
                    <p className="font-bold">Gable  Calculations</p>
                    <FaCalculator size={25}/>
                </div>
                {showCalculations &&
                <>
                    <div className="flex font-bold text-base text-left p-5">
                        <p>
                            To edit or remove an existing gable on the house,
                            click on the gable  you want to edit or remove,
                            and update the dimensions that appear below.
                        </p>
                    </div>
                    <div className="xs:px-0 sm:px-5">
                        <div className="grid grid-cols-2 gap-2">
                            <div className="mb-6 relative">
                                <label className="block font-medium text-textColor mb-2">Height</label>
                                <div className="relative">
                                    <input type="text" placeholder="Height" className="input input-bordered w-full border-black rounded-xl pr-8 "/>
                                </div>
                            </div>
                            <div className="mb-6 relative">
                                <label className="block font-medium text-textColor mb-2">Width</label>
                                <div className="relative">
                                    <input type="text" placeholder="Width" className="input input-bordered w-full border-black rounded-xl pr-8"/>
                                </div>
                            </div>
                        </div>
                        <div className="mb-6">
                        <label className="block font-medium text-textColor mb-2">Design</label>
                        <div className="xs:flex xs:gap-2 sm:flex flex-row justify-around gap-5 lg:flex lg:flex-wrap">
                            {designs.map((design, index) => (
                                <div key={index} className="flex flex-col items-center gap-2">
                                    <div className={`h-16 w-16 rounded-xl shadow-lg cursor-pointer ${design.color}`}>
                                    </div>
                                    <div className="badge badge-neutral text-textWhiteColor p-2 rounded-xl text-xs text-center">
                                        {design.name}
                                    </div>
                                </div>
                            ))}
                        </div>
                        </div>
                        <div className="mb-6">
                            <label className="block font-medium text-textColor mb-2">Colour</label>
                            <div className="xs:flex xs:gap-2 sm:flex flex-row justify-around gap-5 lg:flex lg:flex-wrap">
                                {colours.map((colour, index) => (
                                    <div key={index} className="flex flex-col items-center gap-2">
                                        <div className={`h-16 w-16 rounded-xl shadow-lg cursor-pointer ${colour.color}`}>
                                        </div>
                                        <div className="badge badge-neutral text-textWhiteColor p-2 rounded-xl text-xs text-center">
                                            {colour.name}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="flex flex-col max-w-[200px] m-auto sml:flex sml:flex-row justify-center gap-5 mt-10">
                            {/*}
                            <button className="btn btn-wide bg-slate-300 border-none rounded-none text-textColor hover:bg-hoverColor">Add Gable</button>
                            */}
                            <button 
                                className="btn btn-active btn-neutral border-none rounded-xl text-textWhiteColor hover:bg-hoverColor"
                                onClick={() => setIsVisible(true)} 
                            >
                                Add Gable
                            </button>

                            <button 
                                className={`btn btn-error border-none rounded-xl text-textWhiteColorhover:bg-hoverColor ${isVisible ? '' : 'hidden'}`}
                                onClick={() => setIsVisible(false)}
                            >
                                Remove Gable
                            </button>
                        </div>
                    </div>
                </>
                }   
            </div>
            }

            {/*Windown*/}
            {activeElement === 'window' && 
            <div>
                <div className="flex max-w-[300px] mt-6 mb-4 ml-auto mr-auto p-3 justify-between bg-slate-600 rounded-xl text-textWhiteColor cursor-pointer hover:bg-hoverColor" onClick={toggleCalculations}>
                    <p className="font-bold">Window  Calculations</p>
                    <FaCalculator size={25}/>
                </div>
                {showCalculations &&
                <>
                    <div className="flex font-bold text-base text-left p-5">
                    <p>
                        To edit or remove an existing gable on the house,
                        click on the window you want to edit or remove,
                        and update the dimensions that appear below.
                    </p>
                    </div>
                    <div className="xs:px-0 sm:px-5">
                        <div className="grid grid-cols-2 gap-2">
                            <div className="mb-6 relative">
                                <label className="block font-medium text-textColor mb-2">Height</label>
                                <div className="relative">
                                    <input type="text" placeholder="Height" className="input input-bordered w-full border-black rounded-xl pr-8 "/>
                                </div>
                            </div>
                            <div className="mb-6 relative">
                                <label className="block font-medium text-textColor mb-2">Width</label>
                                <div className="relative">
                                    <input type="text" placeholder="Width" className="input input-bordered w-full border-black rounded-xl pr-8"/>
                                </div>
                            </div>
                        </div>
                    <div className="mb-6">
                    <label className="block font-medium text-textColor mb-2">Design</label>
                    <div className="xs:flex xs:gap-2 sm:flex flex-row justify-around gap-5 lg:flex lg:flex-wrap">
                        {designs.map((design, index) => (
                            <div key={index} className="flex flex-col items-center gap-2">
                                <div className={`h-16 w-16 rounded-xl shadow-lg cursor-pointer ${design.color}`}>
                                </div>
                                <div className="badge badge-neutral text-textWhiteColor p-2 rounded-xl text-xs text-center">
                                    {design.name}
                                </div>
                            </div>
                        ))}
                    </div>
                    </div>
                    <div className="mb-6">
                        <label className="block font-medium text-textColor mb-2">Colour</label>
                        <div className="xs:flex xs:gap-2 sm:flex flex-row justify-around gap-5 lg:flex lg:flex-wrap">
                            {colours.map((colour, index) => (
                                <div key={index} className="flex flex-col items-center gap-2">
                                    <div className={`h-16 w-16 rounded-xl shadow-lg cursor-pointer ${colour.color}`}>
                                    </div>
                                    <div className="badge badge-neutral text-textWhiteColor p-2 rounded-xl text-xs text-center">
                                        {colour.name}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="flex justify-center gap-5 mt-10">
                        <button className="btn btn-active btn-neutral border-none rounded-xl text-textWhiteColor shadow-customhover:bg-hoverColor">Add Window</button>
                    </div>
                    </div>
                </>
                }
            </div>
            }
            {/*Door*/}
            {activeElement === 'door' && 
            <div>
                <div className="flex max-w-[300px] mt-6 mb-4 ml-auto mr-auto p-3 justify-between bg-slate-600 rounded-xl text-textWhiteColor cursor-pointer hover:bg-hoverColor" onClick={toggleCalculations}>
                    <p className="font-bold">Door Calculations</p>
                    <FaCalculator size={25}/>
                </div>
                {showCalculations &&
                <>
                    <div className="flex font-bold text-base text-left p-5">
                        <p>
                            To edit or remove an existing gable on the house,
                            click on the door you want to edit or remove,
                            and update the dimensions that appear below.
                        </p>
                    </div>
                    <div className="xs:px-0 sm:px-5">
                        <div className="grid grid-cols-2 gap-2">
                            <div className="mb-6 relative">
                                <label className="block font-medium text-textColor mb-2">Height</label>
                                <div className="relative">
                                    <input type="text" placeholder="Height" className="input input-bordered w-full border-black rounded-xl pr-8 "/>
                                </div>
                            </div>
                            <div className="mb-6 relative">
                                <label className="block font-medium text-textColor mb-2">Width</label>
                                <div className="relative">
                                    <input type="text" placeholder="Width" className="input input-bordered w-full border-black rounded-xl pr-8"/>
                                </div>
                            </div>
                        </div>
                        <div className="mb-6">
                        <label className="block font-medium text-textColor mb-2">Design</label>
                        <div className="xs:flex xs:gap-2 sm:flex flex-row justify-around gap-5 lg:flex lg:flex-wrap">
                            {designs.map((design, index) => (
                                <div key={index} className="flex flex-col items-center gap-2">
                                    <div className={`h-16 w-16 rounded-xl shadow-lg cursor-pointer ${design.color}`}>
                                    </div>
                                    <div className="badge badge-neutral text-textWhiteColor p-2 rounded-xl text-xs text-center">
                                        {design.name}
                                    </div>
                                </div>
                            ))}
                        </div>
                        </div>
                        <div className="mb-6">
                            <label className="block font-medium text-textColor mb-2">Colour</label>
                            <div className="xs:flex xs:gap-2 sm:flex flex-row justify-around gap-5 lg:flex lg:flex-wrap">
                                {colours.map((colour, index) => (
                                    <div key={index} className="flex flex-col items-center gap-2">
                                        <div className={`h-16 w-16 rounded-xl shadow-lg cursor-pointer ${colour.color}`}>
                                        </div>
                                        <div className="badge badge-neutral text-textWhiteColor p-2 rounded-xl text-xs text-center">
                                            {colour.name}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="flex justify-center gap-5 mt-10">
                            <button className="btn btn-active btn-neutral border-none rounded-xl text-textWhiteColor hover:bg-hoverColor">Add Door</button>
                        </div>
                    </div>
                </>
                }
            </div>
            }
    </div>
  );
};

export default LeftSideBar;